function formatValue(value, isPoint = false) {
  if (isPoint) {
    return value.toLocaleString() + ' pt';
  } else {
    let formatted = Intl.NumberFormat(window.Shopify.locale, {
      style: 'currency',
      currency: window.liquidAjaxCart.cart.currency,
      currencyDisplay: "narrowSymbol"
    }).format(value / 100);
    formatted = formatted.replace('￥', '¥').replace(/\s/g, '');
    return formatted;
  }
}
function animateTotal(fromEl, toEl, isPoint = false, duration = 600) {
  const from = parseInt(fromEl.dataset.total || '0', 10);
  const to = parseInt(toEl.dataset.total || '0', 10);
  if (from === to) return;
  const start = performance.now();
  function step(timestamp) {
    const progress = Math.min((timestamp - start) / duration, 1);
    const current = Math.floor(from + (to - from) * progress);
    if (!isNaN(current)) {
      fromEl.textContent = formatValue(current, isPoint);
    }
    if (progress < 1) {
      requestAnimationFrame(step);
    } else {
      fromEl.dataset.total = to;
    }
  }
  requestAnimationFrame(step);
}
function updatePrice() {
  const totalMap = [
    { from: '#item_subTotal', to: '#cart_total .subTotal_price', isPoint: false },
    { from: '#gift_subTotal', to: '#cart_total .gift_price', isPoint: false },
    { from: '#point_subTotal', to: '#cart_total .point_total', isPoint: true }
  ];
  totalMap.forEach(({ from, to, isPoint }) => {
    const fromEl = document.querySelector(from);
    const toEl = document.querySelector(to);
    if (!fromEl || !toEl) return;
    const fromTotal = parseInt(fromEl.dataset.total || '0', 10);
    const toTotal = parseInt(toEl.dataset.total || '0', 10);
    if (fromTotal !== toTotal) {
      animateTotal(fromEl, toEl, isPoint);
    } else {
      toEl.textContent = formatValue(toTotal, isPoint);
    }
  });
}
function togglePanel(id, isOpen) {
  const el = document.getElementById(id);
  if (el) {
    el.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }
}
function toHalfWidth(str) {
  return str.replace(/[！-～]/g, function(tmpStr) {
    return String.fromCharCode(tmpStr.charCodeAt(0) - 0xFEE0);
  }).replace(/　/g, " ");
}
function showError(message) {
  const errorElement = document.querySelector('.point_code .error');
  if (errorElement) {
    errorElement.textContent = message;
    errorElement.style.display = 'block';
  }
  setLoading(false);
}
function setLoading(isLoading) {
  const button = document.getElementById('code_apply');
  if (!button) return;
  button.disabled = isLoading;
}
function giftOption() {
  const items = window.liquidAjaxCart.cart.items;
  const paidItems = items.filter(item => item.price > 0 && item.product_type !== 'ギフト');
  const paidQty = paidItems.reduce((sum, item) => sum + item.quantity, 0);
  const giftCardItems = items.filter(item => item.handle === 'gift-card');
  const giftCardQty = giftCardItems.reduce((sum, item) => sum + item.quantity, 0);
  const cardSelects = document.querySelectorAll('select.card');
  const cardCountEl = document.querySelector('.card_count');
  const cardButton = document.querySelector('.option_bottom .link');
  let totalCardSelected = 0;
  cardSelects.forEach(select => {
    totalCardSelected += parseInt(select.value, 10) || 0;
  });
  const remaining = Math.max(0, paidQty - giftCardQty - totalCardSelected);
  if (cardCountEl) {
    cardCountEl.textContent = remaining;
  }
  const changeItems = [];
  cardSelects.forEach(select => {
    const selectedQty = parseInt(select.value, 10);
    const variantId = select.querySelector('option')?.getAttribute('variant-id');
    if (!variantId) return;
    const inCartQty = items.find(i => i.variant_id == variantId)?.quantity || 0;
    if (selectedQty > 0) {
      changeItems.push({ id: variantId, qty: selectedQty + inCartQty });
    }
    Array.from(select.options).forEach(opt => {
      const value = parseInt(opt.value, 10);
      const hypotheticalTotal = totalCardSelected - selectedQty + value;
      opt.disabled = hypotheticalTotal > (paidQty - giftCardQty);
    });
    select.disabled = remaining === 0 && selectedQty === 0;
  });
  document.querySelectorAll('.option_quantity select:not(.card)').forEach(select => {
    const selectedQty = parseInt(select.value, 10);
    const variantId = select.querySelector('option')?.getAttribute('variant-id');
    if (!variantId || selectedQty === 0) return;
    const inCartQty = items.find(i => i.variant_id == variantId)?.quantity || 0;
    changeItems.push({ id: variantId, qty: selectedQty + inCartQty });
  });
  if (cardButton) {
    if (changeItems.length > 0) {
      const url = changeItems.map(item => `updates[${item.id}]=${item.qty}`).join('&');
      cardButton.setAttribute('href', `${window.Shopify.routes.root}cart/update?${url}`);
      cardButton.classList.remove('disabled');
    } else {
      cardButton.setAttribute('href', '#');
      cardButton.classList.add('disabled');
    }
  }
}
// reset cart
function resetCart() {
  const cart = window.liquidAjaxCart.cart;
  const items = cart.items;
  const currentAttributes = cart.attributes || {};
  const validTypes = ['通常販売', '限定販売'];
  const hasValidType = items.some(item => validTypes.includes(item.product_type));
  const pointItems = items.filter(item => item.product_type === 'ポイントギフト');
  const customerPoint = parseInt(window.customerData?.point || 0, 10);
  const usedPointTotal = pointItems.reduce((sum, item) => {
    const match = item.variant_title?.match(/\d+/);
    const point = match ? parseInt(match[0], 10) : 0;
    return sum + (point * item.quantity);
  }, 0);
  // reset all
  if (items.length > 0 && !hasValidType) {
    return {
      requests: [
        { type: "clear" },
        {
          type: "update",
          body: {
            attributes: {
              openlogi_delivery_date: null,
              openlogi_delivery_time_slot: null,
              使用ポイント: null,
              保有ポイント: null
            }
          }
        }
      ]
    };
  }
  // reset reward
  if (usedPointTotal > customerPoint) {
    window.removeGift = true;
    const updates = {};

    pointItems.forEach(item => {
      updates[item.key] = 0;
    });

    return {
      requests: [
        {
          type: "update",
          body: {
            updates,
            attributes: {
              保有ポイント: null,
              使用ポイント: null
            }
          }
        }
      ]
    };
  }
  const ownedPoint = pointItems.length > 0 ? String(customerPoint) : null;
  const usedPoint = pointItems.length > 0 ? String(usedPointTotal) : null;
  const currentOwnedPoint = currentAttributes['保有ポイント'] ?? null;
  const currentUsedPoint = currentAttributes['使用ポイント'] ?? null;
  if (
    String(currentOwnedPoint ?? '') === String(ownedPoint ?? '') &&
    String(currentUsedPoint ?? '') === String(usedPoint ?? '')
  ) {
    return;
  }
  return {
    requests: [
      {
        type: "update",
        body: {
          attributes: {
            保有ポイント: ownedPoint,
            使用ポイント: usedPoint
          }
        }
      }
    ]
  };
}
// reset card
function resetCard() {
  const items = window.liquidAjaxCart.cart.items;
  const giftCardItems = items.filter(item => item.handle === 'gift-card');
  const paidItems = items.filter(item => item.price > 0 && item.product_type !== 'ギフト');
  const giftCardQty = giftCardItems.reduce((sum, item) => sum + item.quantity, 0);
  const paidQty = paidItems.reduce((sum, item) => sum + item.quantity, 0);
  if (giftCardQty <= paidQty || giftCardQty === 0) {
    window.removeCard = false;
    return;
  }
  window.removeCard = true;
  const updates = {};
  giftCardItems.forEach(item => {
    updates[item.key] = 0;
  });
  return {
    requests: [
      {
        type: "update",
        body: {
          updates
        }
      }
    ]
  };
}

function cartEvent() {
  // modal
  const targets = ['gift', 'pointgift'];
  const initialHash = location.hash.slice(1);
  if (targets.includes(initialHash)) {
    requestAnimationFrame(() => {
      togglePanel(initialHash, true);
      history.replaceState(null, '', window.location.pathname);
    });
  }
  document.addEventListener('click', function(e) {
    const link = e.target.closest('a[href="#gift"], a[href="#pointgift"]');
    if (link) {
      e.preventDefault();
      e.stopPropagation();
      const id = link.getAttribute('href').slice(1);
      togglePanel(id, true);
      history.replaceState(null, '', window.location.pathname);
      if (id === 'gift') {
        const linkButton = document.querySelector(".option_bottom .link");
        if (linkButton) {
          linkButton.classList.add('disabled');
        }
      }
      return;
    }
    // modal close
    const isModalContent = e.target.closest('.modal_content');
    const isCloseBtn = e.target.closest('.btn-close');
    if (!isModalContent || isCloseBtn) {
      const targets = ['gift', 'pointgift'];
      targets.forEach(id => togglePanel(id, false));
    }
    // loading
    const addLink = e.target.closest('.link');
    if (addLink && addLink.href.includes('/cart/')) {
      addLink.classList.add('loading');
    }
    // remove
    const remove_link = e.target.closest('a[data-role="delete"]');
    if (!remove_link) return;
    e.preventDefault();
    const url = new URL(remove_link.href, window.location.origin);
    const key = url.searchParams.get('id');
    const quantity = url.searchParams.get('quantity');
    if (!key || quantity !== '0') return;
    const items = window.liquidAjaxCart.cart.items;
    const validTypes = ['通常販売', '限定販売'];
    const remainingItems = items.filter(item => item.key !== key);
    const hasValidType = remainingItems.some(item => validTypes.includes(item.product_type));
    if (!hasValidType || remainingItems.length === 0) {
      liquidAjaxCart.clear();
      liquidAjaxCart.update({
        attributes: {
          openlogi_delivery_date: null,
          openlogi_delivery_time_slot: null,
          使用ポイント: null,
          保有ポイント: null
        }
      });
    } else {
      window.location.href = remove_link.href;
    }
  });

  // select change
  document.addEventListener('change', function(e) {
    if (e.target.closest('.product_quantity select')) {
      e.target.closest('.product_quantity select').classList.add('loading');
    }
    if (e.target.closest('.option_quantity select')) {
      giftOption();
    }
  });

  // present code
  document.addEventListener('click', async function(e) {
    const button = e.target.closest('#code_apply');
    if (!button) return;
    const input = document.getElementById('code');
    if (!input) return;
    setLoading(true);
    const rawInput = input.value.trim();
    const code = toHalfWidth(rawInput);
    const rawCodes = input.dataset.code || "";
    const validCodes = rawCodes.split(',');
    if (!validCodes.includes(code)) {
      showError("※コードが間違っている、もしくは利用資格が確認できません。割引クーポンを入力されている場合は、決済画面でご入力ください。");
      return;
    }
    try {
      const response = await fetch('/products.json');
      const data = await response.json();
      let matchedVariant = null;
      let matchedProduct = null;
      for (const product of data.products) {
        const variant = product.variants.find(variant => variant.sku === code);
        if (variant) {
          matchedVariant = variant;
          matchedProduct = product;
          break;
        }
      }
      if (!matchedVariant || !matchedProduct) {
        showError("※コードが間違っている、もしくは利用資格が確認できません。割引クーポンを入力されている場合は、決済画面でご入力ください。");
        return;
      }
      if (matchedProduct.tags.includes('販売終了') || !matchedVariant.available) {
        showError("※入力したアイテムは限定数に達したため配布終了しました");
      } else {
        window.location.href = window.Shopify.routes.root + "cart/add?id=" + matchedVariant.id + "&quantity=1";
      }
    } catch (error) {
      console.error(error);
      showError("※システムエラーが発生しました");
    }
  });
}

// mutation
let mutationInitialized = false;
function initCartMutations() {
  if (mutationInitialized) return;
  if (
    !window.liquidAjaxCart ||
    !window.liquidAjaxCart.cart ||
    typeof window.liquidAjaxCart.conf !== 'function'
  ) {
    requestAnimationFrame(initCartMutations);
    return;
  }
  mutationInitialized = true;
  window.liquidAjaxCart.conf('mutations', [
    resetCart,
    resetCard
  ]);
}

window.addEventListener('DOMContentLoaded', function() {
  cartEvent();
  initCartMutations();
});

// cart update
document.addEventListener("liquid-ajax-cart:request-end", function(event) {
  const { requestState } = event.detail;
  if (requestState.requestType === 'change') {
    updatePrice();
    giftOption();
    const changedInputs = document.querySelectorAll('.product_quantity select.loading');
    changedInputs.forEach(input => input.classList.remove('loading'));
  }
  if (requestState.requestType === 'update') {
    const optionAlert = document.querySelector('.option_alert');
    if (
      window.removeCard === true &&
      optionAlert &&
      !optionAlert.classList.contains('show')
    ) {
      optionAlert.classList.add('show');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      const onAnimationEnd = () => {
        optionAlert.classList.remove('show');
        optionAlert.removeEventListener('animationend', onAnimationEnd);
      };
      optionAlert.addEventListener('animationend', onAnimationEnd);
    }
    const pointAlert = document.querySelector('.point_alert');
    if (
      window.removeGift === true &&
      pointAlert &&
      !pointAlert.classList.contains('show')
    ) {
      pointAlert.classList.add('show');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      const onAnimationEnd = () => {
        pointAlert.classList.remove('show');
        pointAlert.removeEventListener('animationend', onAnimationEnd);
      };
      pointAlert.addEventListener('animationend', onAnimationEnd);
    }
  }
  window.removeCard = false;
  window.removeGift = false;
});